/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { EmailRequestBuilderRequestsMetadata, type EmailRequestBuilder } from './email/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /auth/sign-in
 */
export interface SignInRequestBuilder extends BaseRequestBuilder<SignInRequestBuilder> {
    /**
     * The email property
     */
    get email(): EmailRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const SignInRequestBuilderUriTemplate = "{+baseurl}/auth/sign-in";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SignInRequestBuilderNavigationMetadata: Record<Exclude<keyof SignInRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    email: {
        requestsMetadata: EmailRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
